import { Popup, ScrollView } from "devextreme-react";
import { Position } from "devextreme-react/popup";
import IssueCountPivotGrid from "./IssueCountPivotGrid";
import { useState } from "react";

const IssuesSummaryPopup = ({ setPopupClose, yearMonth }) => {
  const [showPivotGrid, setShowPivotGrid] = useState(false);

  return (
    <Popup
      height={700}
      hideOnOutsideClick={true}
      maxHeight={"99vh"}
      maxWidth={"99vw"}
      onHiding={() => {
        setShowPivotGrid(false);
        setPopupClose();
      }}
      onShown={() => setShowPivotGrid(true)}
      showCloseButton={true}
      title="Issues Summary"
      visible={true}
      width={1280}
    >
      <Position at="center" collision="fit" my="center" />
      <ScrollView direction="both" height="100%" width="100%">
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <div style={{ maxWidth: "600px", width: "100%" }}>
            <IssueCountPivotGrid
              isVisible={showPivotGrid}
              showChart={true}
              target="stat"
              targetName="Issue Status"
              title="Current Status"
              yearMonth={yearMonth}
            />
          </div>
          <div style={{ width: "16px" }} />
          <div style={{ maxWidth: "600px", width: "100%" }}>
            <IssueCountPivotGrid
              isVisible={showPivotGrid}
              showChart={true}
              target="type"
              targetName="Issue Type"
              title="Issue Type"
              yearMonth={yearMonth}
            />
          </div>
        </div>
      </ScrollView>
    </Popup>
  );
};

export default IssuesSummaryPopup;
